
import styles from "./ProductRow.module.css";
import AttributeColumn from "../AttributeColumn/AttributeColumn";
import MetricsColumn from "../MetricsColumn/MetricsColumn";
import ActionsColumn from "../ActionsColumn/ActionsColumn";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toTitleCase, safeParse } from "../../../../utilities/functions";
import AGTable from "../../../../components/AGTable/AGTable";

const ProductRow = (props) => {
    const currentProduct = props?.currentProduct;
    const handleMatchStatus = props.handleMatchStatus;
    const updateMatchType = props.updateMatchType;
    const updateCUP = props.updateCUP;

    const [showImageModal, setShowImageModal] = useState(false);

    let bgColor;
    if (currentProduct?.status === "approved"){
        bgColor = "rgb(195, 232, 215)"
    }
    else if (currentProduct?.status === "rejected"){
        bgColor = "rgb(243, 210, 210)"
    }
    else if (currentProduct?.status === "previously approved"){
        bgColor = "rgb(241, 252, 247)"
    }
    else if (currentProduct?.status === "previously rejected"){
        bgColor = "rgb(247, 235, 235)"
    }

    return (
        <div>
            <Modal size="xl" show={showImageModal}>
                <Modal.Header closeButton onClick={() => setShowImageModal(false)}>
                    <Modal.Title>Match Detail</Modal.Title>
                </Modal.Header>
                {/* {(!currentVertical && source === "upload") ? <Modal.Body>Cannot upload data: Vertical must be selected</Modal.Body> :<Modal.Body>Are you sure you want to submit all changes?</Modal.Body>} */}
                <Modal.Body>
                    <div style={{display: "grid", gap: '30px'}}>
                        <div style={{flex:1, display: "flex", gap: '50px'}}>
                            <div style={{textAlign: 'start', flex: 1}}>
                                <h5><b>{toTitleCase(currentProduct?.search_banner)}</b> - {currentProduct?.sku_name}</h5>
                            </div>
                            <div style={{textAlign: 'start', flex: 1}}>
                                <h5><b>{toTitleCase(currentProduct?.result_banner)}</b> - {currentProduct?.result_sku_name}</h5>
                            </div>
                        </div>
                        <div style={{flex:1, display: "flex"}}>
                            <div className={styles.ProductRowZoomImageWrapper}>
                                <img src={currentProduct?.image_url} alt={currentProduct?.sku_name} class={styles.ProductRowImage}></img>
                            </div>
                            <div className={styles.ProductRowZoomImageWrapper}>
                                <img src={currentProduct?.result_image_url} alt={currentProduct?.result_sku_name} class={styles.ProductRowImage}></img>
                            </div>
                        </div>
                        <div style={{flex:1, display: "flex", gap: "50px"}}>
                            <div style={{textAlign: 'start', flex: 1}}>
                                <h5>Description</h5>
                                <div style={{display: "grid", gap: '20px'}}>
                                    {currentProduct?.description?.split('\n')?.map((part) => {
                                        return <span>{part}</span>
                                    })}
                                </div>
                            </div>
                            <div style={{textAlign: 'start', flex: 1}}>
                                <h5>Description</h5>
                                <div style={{display: "grid", gap: '20px'}}>
                                    {currentProduct?.result_description?.split('\n')?.map((part) => {
                                        return <span>{part}</span>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div style={{flex:1, display: "flex", gap: "50px"}}>
                            <div style={{textAlign: 'start', flex: 1, display: "grid"}}>
                                <h5>Specifications</h5>
                                {
                                    currentProduct?.specs && <AGTable hideFilters data={Object.keys(safeParse(currentProduct?.specs) ?? {})?.map((key) => {
                                        return {
                                            key: key,
                                            value: safeParse(currentProduct?.specs)[key]
                                        }
                                    })}/>
                                }
                            </div>
                            <div style={{textAlign: 'start', flex: 1, display: "grid"}}>
                                <h5>Specifications</h5>
                                {currentProduct?.result_specs && <AGTable hideFilters data={Object.keys(safeParse(currentProduct?.result_specs) ?? {})?.map((key) => {
                                    return {
                                        key: key,
                                        value: safeParse(currentProduct?.result_specs)[key]
                                    }
                                })}/>}
                            </div>
                        </div>
                    </div>
                   
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowImageModal(false)}>
                    Close
                </Button>
 
                </Modal.Footer>
            </Modal>
            <div className={styles.ProductRow} style={{backgroundColor: bgColor}}>
                <div className={styles.ProductRowCard} style={{flex: 2}}>
                    <AttributeColumn data={{                    
                        sku_name: currentProduct?.sku_name,
                        brand: currentProduct?.brand,
                        price: currentProduct?.price,
                        product_url: currentProduct?.product_url,
                        image_url: currentProduct?.image_url,
                        pack_size: currentProduct?.pack_size,
                        pack_volume: currentProduct?.pack_volume,
                        search_banner: currentProduct?.search_banner}}
                    />
                </div>
                <div className={styles.ProductRowCard} style={{flex: 2}}>
                    <AttributeColumn data={{                    
                        sku_name: currentProduct?.result_sku_name,
                        brand: currentProduct?.result_brand,
                        price: currentProduct?.result_price,
                        product_url: currentProduct?.result_product_url,
                        image_url: currentProduct?.result_image_url,
                        pack_size: currentProduct?.result_pack_size,
                        pack_volume: currentProduct?.result_pack_volume,
                        search_banner: currentProduct?.result_banner}}
                    />
                </div>
                <div className={styles.ProductRowCard} style={{flex: 1}}>
                    <div className={styles.ProductRowImageWrapper}>
                        <button onClick={() => setShowImageModal(true)} style={{
                            border: "none",
                            background: "transparent",
                            padding: 0,
                            cursor: "pointer"
                        }}>
                            <img src={currentProduct?.image_url} alt={currentProduct?.sku_name} class={styles.ProductRowImage}></img>
                        </button>
                    </div>
                </div>
                <div className={styles.ProductRowCard} style={{flex: 1}}>
                    <div className={styles.ProductRowImageWrapper}>
                        <button onClick={() => setShowImageModal(true)} style={{
                            border: "none",
                            background: "transparent",
                            padding: 0,
                            cursor: "pointer"
                        }}>
                            <img src={currentProduct?.result_image_url} alt={currentProduct?.result_sku_name} class={styles.ProductRowImage}></img>
                        </button>
                    </div>
                </div>
                <div className={styles.ProductRowCard} style={{flex: 3}}>
                    <MetricsColumn data={{                    
                        similarity_score_sku_name: currentProduct?.similarity_score_sku_name,
                        similarity_score_brand: currentProduct?.similarity_score_brand,
                        similarity_score_price: currentProduct?.similarity_score_price,
                        match_source: currentProduct?.match_source,
                        search_term: currentProduct?.search_term,
                        status: currentProduct?.status,
                        changed: currentProduct?.changed,
                        save_type: currentProduct?.save_type,
                        updated_by: currentProduct?.updated_by,
                        updated_at: currentProduct?.updated_at,
                        ai_suggestion: currentProduct?.ai_suggestion,
                        ai_confidence: currentProduct?.ai_confidence,
                    }}
                    />
                </div>
                <div className={styles.ProductRowCard} style={{flex: 3}}>
                    <ActionsColumn 
                        data={{
                            currentProduct: currentProduct
                        }}
                        handleMatchStatus={handleMatchStatus}
                        updateCUP={updateCUP}
                        updateMatchType={updateMatchType}
                    />
                </div>
            </div>
        </div>

    )
};

export default ProductRow;